import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../services/api";
import { FaEye } from "react-icons/fa";
import { IoRefresh } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import Loading from "../../components/Loader/Loading";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Checkbox from "../../components/common/CheckBox";
import Modal from "../../components/common/Modal";

const GenerateFaq = () => {
  const location = useLocation();
  const { city, domain } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFaqs, setIsLoadingFaqs] = useState(false);
  const [isLoadingPublish, setIsLoadingPublish] = useState(false);
  const [keywords, setKeywords] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [currentKeyword, setCurrentKeyword] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [editedContent, setEditedContent] = useState("");
  const [selectedFaqsMap, setSelectedFaqsMap] = useState(new Map());
  console.log(selectedFaqsMap);
  const [showSelectedFaqs, setShowSelectedFaqs] = useState(false);
  const getDetails = async (keyword) => {
    setIsLoading(true);
    try {
      const res = await api.post(`/api/domains/seo/generate_FAQs`, {
        domain: domain,
        keyword: keyword,
      });
      if (res.status === 200) {
        setKeywords(res.data?.data);

        let blogData = res.data?.data?.output;
        if (typeof blogData === "string") {
          try {
            // First try to parse as JSON
            blogData = JSON.parse(blogData);
          } catch (e) {
            // If JSON parsing fails, try to parse as FAQ format
            blogData = parseFAQString(blogData);
          }
        }
        setFaqs(blogData);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const parseFAQString = (faqString) => {
    const pairs = faqString.split(/\d+\.\s+Q:\s+/).filter(Boolean);

    return pairs.map((pair) => {
      const [questionPart, answerPart] = pair.split(/\s+A:\s+/);

      return {
        q: questionPart?.trim(),
        a: answerPart?.trim(),
        is_live: 0,
      };
    });
  };

  const handleView = async (item) => {
    setCurrentKeyword(item);
    setIsLoadingFaqs(true);
    try {
      const res = await api.post(`/api/domains/seo/generate_FAQs`, {
        city: city,
        industry: domain,
        keyword: item.keyword,
      });
      if (res.status === 200) {
        setKeywords(res.data?.data);
        let blogData = res.data?.data?.output;
        if (typeof blogData === "string") {
          try {
            // First try to parse as JSON
            blogData = JSON.parse(blogData);
          } catch (e) {
            // If JSON parsing fails, try to parse as FAQ format
            blogData = parseFAQString(blogData);
          }
        }
        setFaqs(blogData);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoadingFaqs(false);
    }
  };

  const handlePublish = async () => {
    const faqsToPublish = Array.from(selectedFaqsMap.values());

    if (faqsToPublish.length >= 10) {
      // const updatedFaqs = faqsToPublish.map((faq, index) => ({
      //   ...faq,
      //   is_live: index < 5 ? 1 : 0,
      // }));
      const updatedFaqs = faqsToPublish.map((faq, index) => ({
        FAQ: `Q: ${faq.q} A: ${faq.a}`,
        is_live: index < 5 ? 1 : 0,
      }));
      setIsLoadingPublish(true);

      try {
        const res = await api.post(`/api/domains/seo/publish_FAQs`, {
          FAQs: updatedFaqs,
          domain: domain,
        });

        if (res.status === 200) {
          toast.success("FAQs published successfully");
          // Clear selections after successful publish
          setSelectedFaqsMap(new Map());
        } else {
          toast.error(res.data.message || "Failed to publish FAQs");
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message || "Failed to publish FAQs");
      } finally {
        setIsLoadingPublish(false);
      }
    } else {
      toast.error("Please select at least 10 FAQs");
      return;
    }
  };

  const handleRefresh = () => {
    if (currentKeyword) {
      handleView(currentKeyword);
    }
  };

  const handleSearch = (keyword) => {
    if (domain && keyword) {
      getDetails(keyword);
      setFaqs(null);
    }
  };

  const handleFAQSelection = (index) => {
    const faqKey = `${currentKeyword?.keyword || "unknown"}_${index}`;
    const currentFaq = faqs[index];

    setSelectedFaqsMap((prevMap) => {
      const newMap = new Map(prevMap);

      if (newMap.has(faqKey)) {
        // Remove from selection
        newMap.delete(faqKey);
      } else {
        // Add to selection
        newMap.set(faqKey, {
          ...currentFaq,
        });
      }

      return newMap;
    });
  };

  const renderCards = () => {
    return keywords?.questionTerms?.map((item, idx) => (
      <div className="flex gap-2" key={idx}>
        <div className="border border-gray-200 rounded-lg p-4 mb-3 bg-gray-50 shadow-sm w-[90%]">
          <div>
            <span className="font-semibold">Keyword:</span> {item.keyword}
          </div>
          <div>
            <span className="font-semibold">Volume:</span> {item.volume}
          </div>
          <div>
            <span className="font-semibold">Difficulty:</span>{" "}
            {item.difficulty !== null ? item.difficulty : "N/A"}
          </div>
        </div>
        <div className="cursor-pointer flex items-center justify-center w-[10%]">
          <FaEye
            className="text-lg text-gray-500"
            onClick={() => handleView(item)}
          />
        </div>
      </div>
    ));
  };

  return (
    <>
      {isLoading && <Loading />}
      <div className="flex h-[calc(100vh-50px)] gap-1">
        <div className="w-[30%] max-w-[30%] border border-gray-300 p-4 bg-white h-full overflow-y-auto">
          <div className="text-sm font-bold mb-4 flex items-center justify-center flex-col">
            <h2 className="text-lg font-bold mb-1">
              Enter Keywords to generate FAQs
            </h2>
            <div className="text-sm text-gray-500">{`(${domain})`}</div>
          </div>
          <div className="relative mb-4">
            <input
              type="text"
              placeholder="Search keywords..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="block w-full pr-12 pl-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
            <div className="absolute inset-y-0 right-0 pr-1 flex items-center">
              <button
                onClick={() => handleSearch(searchTerm)}
                className="!bg-[#042A42] text-white p-2 rounded-md hover:!bg-[#031a2e] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#042A42] focus:ring-opacity-50 shadow-sm hover:shadow-md transform hover:scale-105"
                type="button"
              >
                <FaSearch className="h-4 w-4" />
              </button>
            </div>
          </div>
          {selectedFaqsMap.size > 0 ? (
            <button
              onClick={() => setShowSelectedFaqs(true)}
              className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition-colors duration-200 font-medium"
            >
              View Selected FAQs ({selectedFaqsMap.size})
            </button>
          ) : null}

          {isLoading ? null : keywords &&
            keywords?.questionTerms?.length > 0 ? (
            renderCards()
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
              <span className="text-5xl mb-2">🔍</span>
              <div className="text-lg font-semibold mb-1">
                Search for a keyword
              </div>
              <div className="text-sm">
                {keywords
                  ? "No keywords match your search criteria."
                  : "Try selecting a different domain or check back later."}
              </div>
            </div>
          )}
        </div>
        <div className="w-[70%] max-w-[70%] border border-gray-300 p-4 bg-white h-full overflow-y-auto">
          {isLoadingFaqs ? (
            <div className="flex items-center justify-center h-full">
              <img src="/img/loading.gif" className="w-16" alt="Loading..." />
            </div>
          ) : faqs && Array.isArray(faqs) ? (
            <div className="mt-8 p-4 border border-blue-200 rounded-lg bg-blue-50">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold">FAQ Preview</h3>
                <div className="flex gap-3">
                  <button
                    className="btnPrimary !bg-[#042A42] text-white font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200 cursor-pointer"
                    onClick={handleRefresh}
                    disabled={isLoadingPublish}
                  >
                    {isLoadingPublish ? (
                      <img
                        src="/img/loading.gif"
                        className="w-5 h-5 mr-2"
                        alt="Publishing..."
                      />
                    ) : null}
                    <IoRefresh className="w-5 h-5" />
                  </button>
                  <button
                    className={`btnPrimary font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200 ${
                      selectedFaqsMap.size > 0
                        ? "!bg-[#042A42] text-white cursor-pointer"
                        : "!bg-gray-400 text-gray-200 cursor-not-allowed"
                    }`}
                    onClick={() => {
                      if (selectedFaqsMap.size > 0) {
                        // Initialize editedContent with selected FAQs when opening modal
                        const selectedFaqs = Array.from(
                          selectedFaqsMap.values()
                        );
                        const faqsText = selectedFaqs
                          .map(
                            (faq, index) =>
                              `${index + 1}. Q: ${faq.q}\n   A: ${faq.a}`
                          )
                          .join("\n\n");
                        setEditedContent(faqsText);
                        setIsOpen(true);
                      } else {
                        toast.error(" Select FAQs to edit ");
                      }
                    }}
                    // disabled={selectedFaqsMap.size === 0}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div className="space-y-4">
                {faqs.map((faq, index) => {
                  const faqKey = `${
                    currentKeyword?.keyword || "unknown"
                  }_${index}`;
                  const isSelected = selectedFaqsMap.has(faqKey);

                  return (
                    <div
                      key={index}
                      className={`p-4 rounded-lg border ${
                        isSelected
                          ? "border-blue-400 bg-blue-50"
                          : "border-gray-200 bg-white"
                      } transition-all duration-200`}
                    >
                      <div className="flex items-start gap-3">
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleFAQSelection(index)}
                          className="mt-1.5"
                        />
                        <div className="flex-1">
                          <div className="font-semibold text-gray-800 mb-2">
                            Q: {faq.q}
                          </div>
                          <div className="text-gray-600 pl-2 border-l-2 border-gray-200">
                            A: {faq.a}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-between mt-6 pt-4 border-t border-gray-200">
                <div className="text-sm text-gray-600">
                  {selectedFaqsMap.size} FAQs selected
                </div>
                <button
                  className="btnPrimary !bg-[#042A42] text-white font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200"
                  onClick={handlePublish}
                  disabled={isLoadingPublish}
                >
                  {isLoadingPublish ? (
                    <img
                      src="/img/loading.gif"
                      className="w-5 h-5 mr-2 inline"
                      alt="Publishing..."
                    />
                  ) : null}
                  Publish
                </button>
              </div>
            </div>
          ) : (
            // Add an else case for when there's no blog data
            <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
              <div className="text-lg font-semibold mb-1">
                No FAQs generated yet
              </div>
              <div className="text-sm">Select a keyword to generate FAQs</div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />

      <Modal
        open={!isOpen}
        handleModal={() => setIsOpen(false)}
        className="max-w-[50%]"
        title="Edit FAQs"
        modalType="edit"
        handleModalSubmit={(e) => {
          e.preventDefault();
          if (editedContent.trim()) {
            try {
              const faqLines = editedContent.split(/\n\s*\n/);
              const selectedFaqs = Array.from(selectedFaqsMap.values());
              setSelectedFaqsMap((prevMap) => {
                const newMap = new Map(prevMap);
                let mapIndex = 0;

                faqLines.forEach((faqBlock) => {
                  const lines = faqBlock.split("\n");
                  const question = lines[0]
                    ?.replace(/^\d+\.\s*Q:\s*/, "")
                    .trim();
                  const answer = lines[1]?.replace(/^\s*A:\s*/, "").trim();

                  if (question && answer && mapIndex < selectedFaqs.length) {
                    const faqKey = Array.from(newMap.keys())[mapIndex];
                    if (faqKey) {
                      newMap.set(faqKey, {
                        q: question,
                        a: answer,
                        is_live: selectedFaqs[mapIndex]?.is_live || 0,
                      });
                    }
                    mapIndex++;
                  }
                });

                return newMap;
              });

              setFaqs((prevFaqs) => {
                const updatedFaqs = [...prevFaqs];
                const selectedFaqs = Array.from(selectedFaqsMap.values());
                let faqIndex = 0;

                faqLines.forEach((faqBlock) => {
                  const lines = faqBlock.split("\n");
                  const question = lines[0]
                    ?.replace(/^\d+\.\s*Q:\s*/, "")
                    .trim();
                  const answer = lines[1]?.replace(/^\s*A:\s*/, "").trim();

                  if (question && answer && faqIndex < selectedFaqs.length) {
                    const selectedFaq = selectedFaqs[faqIndex];
                    const mainIndex = prevFaqs.findIndex(
                      (faq) =>
                        faq.q === selectedFaq.q && faq.a === selectedFaq.a
                    );

                    if (mainIndex !== -1) {
                      updatedFaqs[mainIndex] = {
                        q: question,
                        a: answer,
                        is_live: selectedFaq.is_live || 0,
                      };
                    }
                    faqIndex++;
                  }
                });

                return updatedFaqs;
              });
            } catch (error) {
              toast.error("Error something went wrong");
              return;
            }
          }

          setIsOpen(false);
        }}
      >
        <div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Edit FAQs
            </label>
            <textarea
              value={editedContent}
              onChange={(e) => {
                setEditedContent(e.target.value);
              }}
              className="w-full h-96 border border-blue-300 rounded-md p-3 font-mono text-sm resize-none"
              placeholder="1. Q: First question\n   A: First answer\n\n2. Q: Second question\n   A: Second answer"
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={!showSelectedFaqs}
        handleModal={() => setShowSelectedFaqs(false)}
        className="max-w-[80%]"
        title={`Selected FAQs (${selectedFaqsMap.size})`}
        modalType="view"
        showFooter={false}
        closeOnly={true}
      >
        <div className="max-h-96 overflow-y-auto">
          {selectedFaqsMap.size > 0 ? (
            <div className="space-y-4">
              {Array.from(selectedFaqsMap.values()).map((faq, index) => (
                <div
                  key={faq.faqKey || index}
                  className="p-4 rounded-lg border border-green-300 bg-green-50"
                >
                  <div className="flex items-start gap-3">
                    <div className="flex-1">
                      <div className="font-semibold text-gray-800 mb-2">
                        Q: {faq.q}
                      </div>
                      <div className="text-gray-600 pl-2 border-l-2 border-gray-200">
                        A: {faq.a}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8"></div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default GenerateFaq;
